module.exports = __webpack_public_path__ + "img/service-resource-2.4944ebde.png";